module.exports = __webpack_public_path__ + "img/bvs_logo_pt.ab4ae7c1.svg";